import axios from "axios";
import "mathquill/build/mathquill.css";
import { useEffect, useState } from "react";
import { addStyles, EditableMathField } from "react-mathquill";
import { Link, useNavigate, useParams } from "react-router-dom";
import Back from "../components/button/back";
addStyles();

const SmartInputOption = ({ value = "", onChange }) => {
  const [isMath, setIsMath] = useState(false);
  const [initialCheckDone, setInitialCheckDone] = useState(false);

  const latexPattern =
    /\\frac|\\sqrt|\\sum|\\int|\\pi|\\theta|\\alpha|\\beta|\\gamma|\\cdot|\\times|\\left|\\right|\\begin|\\end/;

  // Auto detect ONLY on the first load
  useEffect(() => {
    if (!initialCheckDone) {
      setIsMath(latexPattern.test(value));
      setInitialCheckDone(true);
    }
  }, [value, initialCheckDone]);

  const switchMode = (mode) => {
    setIsMath(mode);
    setInitialCheckDone(true);
  };

  return (
    <div className="w-full">
      {/* Toggle */}
      <div className="flex gap-2 mb-1">
        <button
          type="button"
          onClick={() => switchMode(false)}
          className={`px-2 py-1 rounded ${
            !isMath ? "bg-blue-500 text-white" : "bg-gray-200"
          }`}
        >
          Mode Text
        </button>

        <button
          type="button"
          onClick={() => switchMode(true)}
          className={`px-2 py-1 rounded ${
            isMath ? "bg-blue-500 text-white" : "bg-gray-200"
          }`}
        >
          Mode Matematika
        </button>
      </div>

      {/* Input */}
      {!isMath ? (
        <textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="border border-slate-500 rounded-md p-2 w-full min-h-[120px] resize-y"
          placeholder="Tulis teks di sini..."
        />
      ) : (
        <div className="grid">
          <div className="w-full overflow-x-auto">
            <EditableMathField
              latex={value}
              onChange={(mf) => onChange(mf.latex())}
              className="
        w-full
        border rounded bg-white 
        text-base sm:text-lg md:text-xl
        whitespace-nowrap
      "
            />
          </div>
        </div>
      )}
    </div>
  );
};

const SmartInput = ({ value, onChange }) => {
  const [isMath, setIsMath] = useState(false);
  const [manualSwitch, setManualSwitch] = useState(false);

  // Auto detect latex ONLY on first load OR when no manual override
  useEffect(() => {
    if (!manualSwitch) {
      const latexPattern =
        /\\frac|\\sqrt|\\sum|\\int|\\pi|\\theta|\\alpha|\\beta|\\gamma|\\cdot|\\times|\\left|\\right|\\begin|\\end/;
      setIsMath(latexPattern.test(value));
    }
  }, [value, manualSwitch]);

  const switchMode = (mode) => {
    setIsMath(mode);
    setManualSwitch(true); // user manually changed, stop auto detect
  };

  return (
    <div className="relative w-full">
      <div className="flex gap-2 mb-2">
        <button
          type="button"
          className={`px-2 py-1 rounded ${
            !isMath ? "bg-blue-500 text-white" : "bg-gray-200"
          }`}
          onClick={() => switchMode(false)}
        >
          Mode Text
        </button>

        <button
          type="button"
          className={`px-2 py-1 rounded ${
            isMath ? "bg-blue-500 text-white" : "bg-gray-200"
          }`}
          onClick={() => switchMode(true)}
        >
          Mode Matematika
        </button>
      </div>
      {!isMath && (
        <textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="border border-slate-400 rounded-md p-2 w-full min-h-[100px]"
          placeholder="Tulis soal"
        />
      )}
      {isMath && (
        <EditableMathField
          latex={value}
          onChange={(mathField) => onChange(mathField.latex())}
          className="
        w-full
        min-h-20 p-2 border rounded bg-white 
        text-base sm:text-lg md:text-xl
        whitespace-nowrap
      "
        />
      )}
    </div>
  );
};

// const isLatex = (text) => {
//   if (!text) return false;
//   return /\\frac|\\sqrt|\\pi|\\sum|\\int|\\theta|\\alpha|\\beta|\\gamma|\\cdot|\\times|\\left|\\right|\\begin|\\end/.test(
//     text
//   );
// };

const EditQuestion = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [question, setQuestion] = useState({
    kelas: "",
    rombel: "",
    semester: "",
    mapel: "",
    jenis: "",
    TP: "",
    kode: "",
    question: [],
  });
  const deleteImageFromServer = async (fileId) => {
    if (!fileId) return;
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}api/questions/delete-image`,
        { fileId },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
    } catch (err) {
      console.warn("Gagal menghapus gambar dari server:", err.message);
    }
  };

  useEffect(() => {
    const fetchQuestion = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}api/questions/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        const fetchedQuestion = response.data;
        if (fetchedQuestion.question.length > 0) {
          setQuestion(fetchedQuestion);
        } else {
          setQuestion({
            ...fetchedQuestion,
            question: [
              {
                text: "",
                type: "essay",
                bobot: 1,
                correctAnswer: "",
                options: [],
                optionCorrectAnswer: [],
                keyJawabanBenar: 1,
              },
            ],
          });
        }
      } catch (error) {
        console.error("Error fetching question:", error);
      }
    };

    fetchQuestion();
  }, [id]);

  const moveQuestion = (fromIndex, toIndex) => {
    if (
      toIndex < 0 ||
      toIndex >= question.question.length ||
      fromIndex === toIndex
    ) {
      return;
    }

    setQuestion((prev) => {
      const updatedQuestions = [...prev.question];
      const [moved] = updatedQuestions.splice(fromIndex, 1);
      updatedQuestions.splice(toIndex, 0, moved);
      return {
        ...prev,
        question: updatedQuestions,
      };
    });
  };

  const handleChange = (e) => {
    setQuestion({ ...question, [e.target.name]: e.target.value });
  };

  const handleQuestionChange = (e, index) => {
    const { name, value } = e.target;
    const updatedQuestions = [...question.question];
    updatedQuestions[index][name] = value;
    if (name === "type" && value === "essay") {
      updatedQuestions[index].options = [];
      updatedQuestions[index].correctAnswer = "";
    } else if (name === "type" && value === "multipleChoice") {
      updatedQuestions[index].correctAnswer = undefined;
    } else if (name === "type" && value === "isian") {
      updatedQuestions[index].keyJawabanBenar = "";
      updatedQuestions[index].optionCorrectAnswer = [];
    }
    setQuestion({ ...question, question: updatedQuestions });
  };
  const handleOptionIsianChange = (e, questionIndex, optionIndex) => {
    const updatedQuestions = [...question.question];
    updatedQuestions[questionIndex].optionCorrectAnswer[optionIndex] =
      e.target.value;
    setQuestion({ ...question, question: updatedQuestions });
  };

  const handleOptionChange = (e, questionIndex, optionIndex) => {
    const { name, value, checked } = e.target;
    const updatedQuestions = [...question.question];
    const updatedOptions = [...updatedQuestions[questionIndex].options];
    if (name === "text") {
      updatedOptions[optionIndex].text = value;
    } else if (name === "isCorrect") {
      updatedOptions[optionIndex].isCorrect = checked;
    } else if (name === "gambar") {
      // Handle image upload for options
      handleOptionImageUpload(e, questionIndex, optionIndex);
      return; // Return early after handling image upload
    }
    updatedQuestions[questionIndex].options = updatedOptions;
    setQuestion({ ...question, question: updatedQuestions });
  };

  const handleOptionImageUpload = async (e, questionIndex, optionIndex) => {
    const file = e.target.files[0];
    if (!file) return;

    const oldFileId =
      question.question[questionIndex]?.options?.[optionIndex]?.gambar
        ?.fileId || null;

    const formData = new FormData();
    formData.append("image", file);
    if (oldFileId) formData.append("oldFileId", oldFileId); // untuk hapus gambar lama di server

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}api/questions/upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      const { fileId, filename, mimetype } = response.data.image;

      const updatedQuestions = [...question.question];
      updatedQuestions[questionIndex].options[optionIndex].gambar = {
        fileId,
        filename,
        mimetype,
      };

      setQuestion({ ...question, question: updatedQuestions });
      console.log(`Option image uploaded: ${filename}`);
    } catch (error) {
      console.error(
        "Upload image failed:",
        error.response?.data || error.message,
      );
    }
  };

  const addOption = (index) => {
    const updatedQuestions = [...question.question];
    updatedQuestions[index].options.push({ text: "", isCorrect: false });
    setQuestion({ ...question, question: updatedQuestions });
  };

  const removeOption = async (questionIndex, optionIndex) => {
    const option = question.question[questionIndex].options[optionIndex];
    if (option?.gambar?.fileId) {
      await deleteImageFromServer(option.gambar.fileId);
    }

    const updatedQuestions = [...question.question];
    updatedQuestions[questionIndex].options.splice(optionIndex, 1);
    setQuestion({ ...question, question: updatedQuestions });
  };

  const addQuestion = () => {
    const newQuestion = {
      text: "",
      type: "essay",
      bobot: 1,
      correctAnswer: "",
      keyJawabanBenar: 1,
      options: [],
    };
    const updatedQuestions = [...question.question, newQuestion];
    const newKode = question.kode ? `${parseInt(question.kode) + 1}` : "1";
    setQuestion((prevState) => ({
      ...prevState,
      kode: newKode,
      question: updatedQuestions,
    }));
  };

  const removeQuestion = async (index) => {
    if (
      !window.confirm(
        `Apakah anda yakin akan menghapus pertanyaan nomor ${index + 1} ini ?`,
      )
    )
      return;

    const targetQuestion = question.question[index];

    // Hapus gambar pertanyaan
    if (targetQuestion.gambar?.fileId) {
      await deleteImageFromServer(targetQuestion.gambar.fileId);
    }

    // Hapus gambar dari setiap opsi jika ada
    if (targetQuestion.options?.length > 0) {
      for (const opt of targetQuestion.options) {
        if (opt.gambar?.fileId) {
          await deleteImageFromServer(opt.gambar.fileId);
        }
      }
    }

    const updatedQuestions = [...question.question];
    updatedQuestions.splice(index, 1);

    const newKode = question.kode ? `${parseInt(question.kode) - 1}` : "1";
    setQuestion({ ...question, kode: newKode, question: updatedQuestions });
  };

  const handleImageUpload = async (e, index) => {
    const file = e.target.files[0];
    if (!file) return;

    const oldFileId = question.question[index]?.gambar?.fileId || null;

    const formData = new FormData();
    formData.append("image", file);
    if (oldFileId) formData.append("oldFileId", oldFileId);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}api/questions/upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      const { fileId, filename, mimetype } = response.data.image;

      const updatedQuestions = [...question.question];
      updatedQuestions[index].gambar = {
        fileId,
        filename,
        mimetype,
      };

      setQuestion({ ...question, question: updatedQuestions });
      console.log(`Question image uploaded: ${filename}`);
    } catch (error) {
      console.error(
        "Error uploading question image:",
        error.response?.data || error.message,
      );
    }
  };

  // Fungsi untuk menambahkan option baru
  const handleAddOption = (questionIndex) => {
    const updatedQuestions = [...question.question];
    updatedQuestions[questionIndex].optionCorrectAnswer.push("");
    setQuestion({ ...question, question: updatedQuestions });
  };

  // Fungsi untuk menghapus option
  const handleRemoveOption = (questionIndex, optionIndex) => {
    const updatedQuestions = [...question.question];
    updatedQuestions[questionIndex].optionCorrectAnswer.splice(optionIndex, 1);
    setQuestion({ ...question, question: updatedQuestions });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      await axios.put(
        `${process.env.REACT_APP_API_URL}api/questions/${id}`,
        question,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      navigate(`/guru/elearning-guru/${question.mapel}`);
    } catch (error) {
      console.error("Error updating question:", error);
    }
  };

  return (
    <div className=" grid min-h-screen w-screen bg-blue-100">
      <div className="grid justify-center py-5">
        <h2 className="text-2xl font-bold">Edit Pertanyaan</h2>
      </div>
      <div className=" flex justify-center w-screen">
        <div className="grid grid-cols-1 w-full max-w-screen-md px-4 sm:px-6 py-5 bg-white rounded-lg mx-auto">
          <form onSubmit={handleSubmit}>
            <div>
              <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 border border-slate-500 rounded-md p-4 overflow-x">
                <div>
                  <label className="font-bold">Kelas : </label>
                  <select
                    name="kelas"
                    value={question.kelas}
                    onChange={handleChange}
                    required
                    className="rounded-lg py-2 px-4 border-2 w-full"
                  >
                    <option value="">Kelas</option>
                    {["1", "2", "3", "4", "5", "6"].map((kelas) => (
                      <option key={kelas} value={kelas}>
                        {kelas}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="font-bold">Rombel : </label>
                  <select
                    name="rombel"
                    value={question.rombel}
                    onChange={handleChange}
                    required
                    className="rounded-lg px-4 py-2 border-2 w-full"
                  >
                    <option value="">Rombel</option>
                    {["A", "B", "C", "D"].map((rombel) => (
                      <option key={rombel} value={rombel}>
                        {rombel}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="font-bold">Semester : </label>
                  <select
                    name="semester"
                    value={question.semester}
                    onChange={handleChange}
                    required
                    className="rounded-lg px-4 py-2 border-2 w-full"
                  >
                    <option value="">Semester</option>
                    {["1", "2"].map((semester) => (
                      <option key={semester} value={semester}>
                        {semester}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="font-bold">Mapel : </label>
                  <select
                    name="mapel"
                    value={question.mapel}
                    onChange={handleChange}
                    required
                    className="rounded-lg px-4 py-2 border-2 w-full"
                  >
                    <option value="">Mapel</option>
                    {[
                      "IPA",
                      "IPS",
                      "MTK",
                      "BIndo",
                      "BIng",
                      "IPAS",
                      "PAI",
                      "PKN",
                      "PJOK",
                      "SENIBUDAYA",
                      "MULOK",
                      "Koding",
                    ].map((mapel) => (
                      <option key={mapel} value={mapel}>
                        {mapel}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="font-bold">Jenis : </label>
                  <select
                    name="jenis"
                    value={question.jenis}
                    onChange={handleChange}
                    required
                    className="rounded-lg px-4 py-2 border-2 w-full"
                  >
                    <option value="">Jenis</option>
                    {[
                      "Latihan",
                      "Tugas",
                      "PR",
                      "UH",
                      "STS",
                      "SAS",
                      "Praktikum",
                    ].map((jenis) => (
                      <option key={jenis} value={jenis}>
                        {jenis}
                      </option>
                    ))}
                  </select>
                </div>
                {question.jenis !== "SAS" && question.jenis !== "STS" && (
                  <div className="mt-2">
                    <label className="font-bold">TP :</label>
                    <select
                      name="TP"
                      value={question.TP || ""}
                      onChange={handleChange}
                      required
                      className="rounded-lg px-4 py-2 border-2 w-full"
                    >
                      <option value="">Pilih TP</option>
                      {Array.from({ length: 20 }, (_, i) => (
                        <option key={i + 1} value={`TP${i + 1}`}>
                          TP {i + 1}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
                <div>
                  <label className="font-bold">Jumlah soal : </label>
                  <div className="rounded-lg px-4 py-2 w-full">
                    {question.kode}
                  </div>
                </div>
              </div>

              <div>
                <ul>
                  {question.question?.map((q, index) => (
                    <li
                      key={index}
                      className="grid gap-y-5 mb-5 border border-slate-500 shadow-lg mt-2 p-2 rounded-lg"
                    >
                      <div className="space-x-2">
                        {index > 0 && (
                          <button
                            type="button"
                            onClick={() => moveQuestion(index, index - 1)}
                            className="bg-blue-500 text-white px-2 py-1 rounded hover:bg-blue-600"
                          >
                            ↑ naik kan urutan soal
                          </button>
                        )}
                        {index < question.question.length - 1 && (
                          <button
                            type="button"
                            onClick={() => moveQuestion(index, index + 1)}
                            className="bg-green-500 text-white px-2 py-1 rounded hover:bg-green-600"
                          >
                            ↓ turun kan urutan soal
                          </button>
                        )}
                      </div>

                      <h3 className="font-bold">No. {index + 1}</h3>
                      {/* Display the question number */}
                      <div className="grid">
                        <div className="grid">
                          <label>Pertanyaan:</label>

                          {/* Jika latex → tampilkan EditableMathField */}
                          <div className="w-full overflow-x-auto">
                            <div className="w-full overflow-x-auto overflow-y-hidden scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200">
                              <SmartInput
                                value={q.text}
                                onChange={(val) => {
                                  const e = {
                                    target: { name: "text", value: val },
                                  };
                                  handleQuestionChange(e, index);
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <label>Upload Gambar:</label>
                        <input
                          type="file"
                          onChange={(e) => handleImageUpload(e, index)}
                        />
                        {q.gambar?.filename && (
                          <div>
                            <img
                              src={`${process.env.REACT_APP_API_URL}api/questions/image/${q.gambar.filename}`}
                              alt={`Gambar Pertanyaan ${index + 1}`}
                              style={{ width: "100px", height: "auto" }}
                            />
                          </div>
                        )}
                      </div>

                      <div>
                        <label>Jenis : </label>
                        <select
                          name="type"
                          value={q.type}
                          className="border border-slate-500 px-3 rounded-lg"
                          onChange={(e) => handleQuestionChange(e, index)}
                        >
                          <option value="essay">Essay</option>
                          <option value="multipleChoice">Pilihan Ganda</option>
                          <option value="isian">Isian</option>
                        </select>
                      </div>
                      <div>
                        <label>Bobot : </label>
                        <input
                          type="number"
                          name="bobot"
                          value={q.bobot}
                          className="border border-slate-500 px-3 rounded-lg"
                          onChange={(e) => handleQuestionChange(e, index)}
                          step="any"
                        />
                      </div>
                      {q.type === "multipleChoice" && (
                        <div className="w-full">
                          <label className="block text-sm font-semibold">
                            Opsi Jawaban:
                          </label>
                          <ul>
                            {q.options?.map((option, i) => (
                              <li
                                key={i}
                                className="flex flex-col sm:flex-row gap-2 sm:gap-4 my-2 w-full bg-blue-100 p-3 sm:bg-white s:p-0 "
                              >
                                <SmartInputOption
                                  value={option.text}
                                  onChange={(val) => {
                                    const e = {
                                      target: {
                                        name: "text",
                                        value: val,
                                      },
                                    };
                                    handleOptionChange(e, index, i);
                                  }}
                                />

                                <div className="flex items-center gap-2">
                                  <label className="flex items-center gap-2 text-sm">
                                    <input
                                      type="checkbox"
                                      name="isCorrect"
                                      checked={option.isCorrect}
                                      onChange={(e) =>
                                        handleOptionChange(e, index, i)
                                      }
                                      className="w-5 h-5 border-2 border-slate-300 rounded-md checked:bg-blue-500 checked:border-blue-500 focus:ring-2 focus:ring-blue-300 transition-all duration-200"
                                    />
                                    <p className="text-sm text-gray-700">
                                      Benar
                                    </p>
                                  </label>
                                </div>
                                <div className="">
                                  <label className="block text-sm">
                                    Upload Gambar:
                                  </label>
                                  <input
                                    type="file"
                                    name="gambar"
                                    className="border border-slate-500 rounded-md w-full p-2 text-sm"
                                    onChange={(e) =>
                                      handleOptionImageUpload(e, index, i)
                                    }
                                  />
                                  {option.gambar?.filename && (
                                    <div className="mt-2">
                                      <img
                                        src={`${process.env.REACT_APP_API_URL}api/questions/image/${option.gambar.filename}`}
                                        alt={`Gambar Opsi ${i + 1}`}
                                        className="w-[100px] h-auto"
                                      />
                                    </div>
                                  )}
                                </div>

                                <button
                                  className="bg-red-400 text-white rounded-lg py-1 px-3 mt-2 sm:mt-0 sm:ml-2 w-full sm:w-auto"
                                  type="button"
                                  onClick={() => removeOption(index, i)}
                                >
                                  Hapus Opsi
                                </button>
                              </li>
                            ))}
                          </ul>
                          <button
                            type="button"
                            className="bg-blue-500 text-white rounded-lg py-2 px-4 mt-4 w-full sm:w-auto"
                            onClick={() => addOption(index)}
                          >
                            Tambah Opsi
                          </button>
                        </div>
                      )}

                      {q.type === "essay" && (
                        <div className="grid">
                          <label>Jawaban Benar:</label>
                          <textarea
                            type="text"
                            name="correctAnswer"
                            value={q.correctAnswer || ""}
                            className="border border-slate-500 px-3 rounded-lg"
                            onChange={(e) => handleQuestionChange(e, index)}
                          />
                        </div>
                      )}
                      {q.type === "isian" && (
                        <div className="grid">
                          {/* Input untuk keyJawabanBenar */}
                          <label>Berapa Jawaban Benar:</label>
                          <input
                            type="number"
                            name="keyJawabanBenar"
                            value={q.keyJawabanBenar || ""}
                            className="border border-slate-500 px-3 rounded-lg"
                            onChange={(e) => handleQuestionChange(e, index)}
                            min={1}
                          />

                          {/* Input untuk optionCorrectAnswer */}
                          <label>Option Correct Answer:</label>
                          {q.optionCorrectAnswer.map((answer, idx) => (
                            <div
                              key={idx}
                              className="flex items-center space-x-2 mb-2"
                            >
                              <input
                                type="text"
                                name={`optionCorrectAnswer-${idx}`}
                                value={answer || ""}
                                className="border border-slate-500 px-3 rounded-lg"
                                onChange={(e) =>
                                  handleOptionIsianChange(e, index, idx)
                                }
                              />
                              <button
                                type="button"
                                className="bg-red-500 text-white px-2 py-1 rounded"
                                onClick={() => handleRemoveOption(index, idx)}
                              >
                                Hapus
                              </button>
                            </div>
                          ))}

                          {/* Tombol untuk menambah option */}
                          <button
                            type="button"
                            className="bg-blue-500 text-white px-3 py-2 rounded"
                            onClick={() => handleAddOption(index)}
                          >
                            Tambah Option
                          </button>
                        </div>
                      )}
                      <div className="flex justify-end">
                        <div className=" mt-4 bg-red-400 rounded-md py-2 px-5">
                          <button
                            type="button"
                            onClick={() => removeQuestion(index)}
                          >
                            Hapus Pertanyaan
                          </button>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="flex justify-start">
                <div className=" py-2 bg-green-300 my-5 px-5 font-bold mb-20 rounded-md">
                  <button type="button" onClick={addQuestion}>
                    Tambah Pertanyaan
                  </button>
                </div>
              </div>
            </div>{" "}
            <div className="flex justify-center bg-blue-400 py-2 rounded-md">
              <button type="submit">Submit</button>
            </div>
          </form>
        </div>
      </div>

      <div className="flex justify-center my-10">
        <Link to={"/guru"}>
          <Back />
        </Link>
      </div>
    </div>
  );
};

export default EditQuestion;
